import{registerElementSafely as r}from"@cds/core/internal";import{CdsProgressCircle as e}from"./progress-circle.element.js";r("cds-progress-circle",e);
